var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Modal2 } from '../../common/Modal';
import CalendarInput from '../../common/CalendarInput';
import regEx from '../../../utils/regex';
import { List, ListItemInput, ListItemSwitch, ListItemCurrencyInput, ListItemIntegerInput, ListItemTextArea, } from '@bootstraplabs/bsw-common-react';
import { thousandSeparator } from '../../../utils/utils';
import { quantityWithLimitationMessage, amountPaidMessage, holderNameMessage, feebackTypeName, holderEmailMessage, feebackTypeEmail, } from '../../../utils/messages';
export default function CreateShareCertificateModal(props) {
    var resetIssuedAt = function () { return new Date().toISOString().slice(0, 10); };
    // State
    var _a = React.useState('1'), quantity = _a[0], setQuantity = _a[1];
    var _b = React.useState(String(props.nominalValue)), amountPaid = _b[0], setAmountPaid = _b[1];
    var _c = React.useState(''), sharePrice = _c[0], setSharePrice = _c[1];
    var _d = React.useState(''), holderName = _d[0], setHolderName = _d[1];
    var _e = React.useState(''), holderEmail = _e[0], setHolderEmail = _e[1];
    var _f = React.useState(true), typeDate = _f[0], setTypeDate = _f[1];
    var _g = React.useState(resetIssuedAt), issuedAtDate = _g[0], setIssuedAtDate = _g[1];
    var _h = React.useState(false), calendarIsOpen = _h[0], setCalendarIsOpen = _h[1];
    var _j = React.useState(''), remarks = _j[0], setRemarks = _j[1];
    var quantityNotOk = Number(quantity) < 1 ||
        Number(quantity) > props.availableQuantity ||
        Number(quantity) > 2147483647;
    var amountPaidNotOk = Number(amountPaid) < props.nominalValue * Number(quantity) ||
        Number(amountPaid) <= 0 ||
        Number(amountPaid) > 1000000000000;
    var holderNameNotOk = (!holderName && !holderEmail) || holderName.length > 100;
    var holderEmailNotOk = (!holderName && !holderEmail) ||
        (holderEmail && regEx.email.test(holderEmail.toLowerCase()) === false) ||
        holderEmail.length > 100;
    var disabled = quantityNotOk ||
        amountPaidNotOk ||
        holderNameNotOk ||
        holderEmailNotOk ||
        remarks.trim().length > 1000;
    // Note: The textInput will only accept 1000 characters and cut the text after 1000 char.
    // Consequently the disable function will not be utilized as long as
    // a supported browser is used, and the HTMLInputElement is displayed as expected.;
    // Helper
    function dateConfirm(datePicked, date) {
        if (datePicked) {
            return date;
        }
        return undefined;
    }
    var confirm = function () {
        props.onConfirm({
            quantity: Number(quantity),
            amountPaid: Number(amountPaid),
            holderName: holderName.trim() || undefined,
            holderEmail: holderEmail.trim().toLowerCase() || undefined,
            issuedAt: dateConfirm(typeDate, issuedAtDate),
            remarks: remarks.trim() || '',
        });
        setQuantity('1');
        setAmountPaid(String(props.nominalValue));
        setSharePrice('');
        setHolderName('');
        setHolderEmail('');
        setIssuedAtDate(resetIssuedAt());
        setCalendarIsOpen(false);
        setRemarks('');
    };
    var cancel = function () {
        props.onCancel();
    };
    return (_jsx(Modal2, __assign({ "data-test": "modal-create-share-certificate", title: "Create Share Certificate", open: props.open, onCancel: cancel, onConfirm: confirm, disabled: disabled }, { children: _jsxs(List, { children: [_jsx(ListItemInput, { labelWidth: 200, type: "text", label: "Share class", value: props.shareClassName, disabled: true }, void 0),
                _jsx(ListItemIntegerInput, { labelWidth: 200, label: "Quantity", value: quantity, onChange: function (value) {
                        var pricePerShare = Number(amountPaid) / Number(value);
                        setQuantity(value);
                        setSharePrice(String(pricePerShare));
                    }, placeholder: "10,000", description: "Available quantity in share class " + props.shareClassName + ": " + thousandSeparator(props.availableQuantity), feedback: quantityWithLimitationMessage(Number(quantity), props.availableQuantity), feedbackType: "warn" }, void 0),
                _jsx(ListItemCurrencyInput, { labelWidth: 200, label: "Amount Paid", value: amountPaid, onChange: function (value) {
                        var pricePerShare = Number(value) / Number(quantity);
                        setSharePrice(String(pricePerShare));
                        setAmountPaid(value);
                    }, placeholder: "10.00 USD", description: "The total amount paid", feedback: amountPaidMessage(Number(amountPaid), props.nominalValue, Number(quantity)), feedbackType: "warn" }, void 0),
                _jsx(ListItemCurrencyInput, { disabled: true, labelWidth: 200, label: "Share Price", value: sharePrice, decimalScale: 4, description: 'Calculated' }, void 0),
                _jsx(ListItemInput, { labelWidth: 200, type: "text", label: "Holder Name", value: holderName, onChange: setHolderName, placeholder: "Jane Smith", feedback: holderNameMessage(holderName, holderEmail), feedbackType: feebackTypeName(holderName, holderEmail) }, void 0),
                _jsx(ListItemInput, { labelWidth: 200, type: "text", label: "Holder Email", value: holderEmail, onChange: setHolderEmail, placeholder: "jane@example.com", feedback: holderEmailMessage(holderEmail, holderName), feedbackType: feebackTypeEmail(holderEmail, holderName) }, void 0),
                _jsx(ListItemSwitch, { primary: "Enable Issued Date", wrapPrimary: true, checked: typeDate, onClick: function () { return setTypeDate(!typeDate); } }, void 0),
                typeDate ? (_jsx(CalendarInput, { labelWidth: 200, label: "Issued At", date: issuedAtDate, onChange: function (date) { return setIssuedAtDate(date.slice(0, 10)); }, isCalendarOpen: calendarIsOpen, showCalendar: setCalendarIsOpen }, void 0)) : null,
                _jsx(ListItemTextArea, { labelWidth: 200, label: "Remarks", value: remarks, onChange: setRemarks }, void 0)] }, void 0) }), void 0));
}
//# sourceMappingURL=create-share-certificate-modal.js.map